import { name as packageName, version as packageVersion } from '../../../package.json';

export var hoveredPayload = {
  action: 'displayed',
  actionSubject: 'tooltip',

  attributes: {
    componentName: 'tooltip',
    packageName: packageName,
    packageVersion: packageVersion
  }
};

export var unhoveredPayload = {
  action: 'hidden',
  actionSubject: 'tooltip',

  attributes: {
    componentName: 'tooltip',
    packageName: packageName,
    packageVersion: packageVersion
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/tooltip/dist/esm/components/utils/analytics-payloads.js
// module id = 728
// module chunks = 0